import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

// Define the TS type for the counter slice's state
export interface FilterState {
  image: string,
  filter: object
}

// Define the initial value for the slice state
const initialState: FilterState = {
  image: 'initString',
  filter: { initObject: "empty" }
}

// Slices contain Redux reducer logic for updating state, and
// generate actions that can be dispatched to trigger those updates.
export const filterSlice = createSlice({
  name: 'filter',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setImage: (state, action: PayloadAction<string>) => {
      state.image = action.payload
    },
    setFilter: (state, action: PayloadAction<object>) => {
      state.filter = action.payload
    }
  }
})

// Export the generated action creators for use in components
export const { setImage, setFilter } = filterSlice.actions

// Export the slice reducer for use in the store configuration
export default filterSlice.reducer